export function getUserForSignupSubmission(state) {
  const { isAnonymousUser, emailOrPhone, name } = state.user;

  if (isAnonymousUser) {
    // anonymousUser. We do need to send user data.
    return {
      name,
      emailOrPhone,
    };
  } else {
    // currently logged in user. Do not need to include user data.
    return null;
  }
}
